var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComparisonVs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 108,
    viewBox: "0 0 108 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53.9224,
    cy: 53.6627,
    r: 53.6627,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.0569 41.1252L46.6889 66.3252H40.6769L30.3449 41.1252H36.8249L43.8089 59.1972L50.7209 41.1252H57.0569ZM58.7095 64.5252V58.9452C62.5975 61.2852 65.1175 62.0052 67.2775 62.0052C69.4015 62.0052 70.5895 61.1052 70.5895 59.6652C70.5895 58.5492 69.9055 57.7212 67.9615 56.9292L63.4615 55.0572C59.8975 53.5812 58.3135 51.3492 58.3135 48.3252C58.3135 43.9692 61.6615 40.7652 67.6015 40.7652C70.9495 40.7652 73.5415 41.6292 75.2335 42.6732V48.5412C71.9215 46.2732 69.3655 45.5892 67.2415 45.5892C65.4055 45.5892 64.2895 46.5252 64.2895 47.7492C64.2895 48.7572 64.9375 49.5852 66.7735 50.3412L71.1655 52.1412C75.0895 53.7612 76.7455 55.8852 76.7455 59.0532C76.7455 63.5172 73.1095 66.6852 67.3495 66.6852C63.9295 66.6852 61.0135 65.8932 58.7095 64.5252Z",
    fill: "#6629D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComparisonVs);
export default __webpack_public_path__ + "static/media/comparison-VS.4c6cd6998109077bb0e4cb60d74c9788.svg";
export { ForwardRef as ReactComponent };